import axios from 'axios';

const GetDistanceBetween = async (long1, lat1, long2, lat2) => {
	const accessToken = `?access_token=${process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN}`;

	return await axios
		.get(
			`https://api.mapbox.com/directions/v5/mapbox/driving/${long1},${lat1};${long2},${lat2}${accessToken}`
		)
		.then(function (response) {
			const inMetres = response.data.routes[0].distance;

			const inMiles = inMetres / 1609;
			return inMiles.toFixed(1);
		})
		.catch((err) => {
			console.log(err);
			return 0;
		});
};

export default GetDistanceBetween;
